import { LogOut } from 'lucide-react'
import { Link, Outlet, Navigate, useLocation } from 'react-router-dom'
import styles from './styles.module.css'
import { useAuth } from '../../../context/AuthContext'

const sidebarLinks = [
  { label: 'Landing', path: '/landing' },
  { label: 'About Us', path: '/aboutUs' },
  { label: 'Contact Us', path: '/contactUs' },
  { label: 'Subsidiary Page', path: '/subsidiaryPage' },
  { label: 'Subsidiaries', path: '/subsidiaries' },
  { label: 'News', path: '/news' },
  { label: 'Projects', path: '/projects' },
  { label: 'Services', path: '/services' },
  { label: 'Team', path: '/team' }
]

const DashboardLayout = () => {
  const { isLoggedIn, logout } = useAuth()
  const { pathname } = useLocation()

  if (!isLoggedIn) {
    return <Navigate to="/login" />
  }

  return (
    <div className={styles.container}>
      <div className={styles.sidebarContainer}>
        <div className={styles.sidebar}>
          <div>
            <h2>Side Bar</h2>
            <ul>
              {sidebarLinks.map((link) => (
                <li
                  className={`${pathname === link.path && styles.activePage}`}
                >
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className={styles.footerContainer}>
            <button className={styles.logOut} onClick={logout}>
              <LogOut className={styles.logoutIcon} />
              Logout
            </button>

            <span className={styles.footerText}>
              Crafted by{' '}
              <a
                title="Crafted by Artisans"
                href="https://artisans.ge/ka"
                target="_blank"
                rel="noopener"
              >
                ARTISANS
              </a>
            </span>
          </div>
        </div>
      </div>

      <div className={styles.mainView}>
        <Outlet />
      </div>
    </div>
  )
}

export default DashboardLayout
